export default __webpack_public_path__ + "static/media/top-drive.e5b30d9f.jpg";